'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../node_modules/tslib/tslib.es6.js');
var jsxRuntime = require('react/jsx-runtime');

var SvgFilePdf48 = function (_a) {
    var title = _a.title, titleId = _a.titleId, props = tslib_es6.__rest(_a, ["title", "titleId"]);
    return (jsxRuntime.jsxs("svg", tslib_es6.__assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-labelledby": titleId }, props, { children: [title ? jsxRuntime.jsx("title", tslib_es6.__assign({ id: titleId }, { children: title })) : null, jsxRuntime.jsxs("g", tslib_es6.__assign({ fill: "none", fillRule: "evenodd" }, { children: [jsxRuntime.jsx("path", { fill: "none", d: "M0 .5h48v48H0z" }), jsxRuntime.jsx("path", { d: "M35.25 18.5H27v-8.25m8.25 8.353V38.75H12v-28.5h15.016l8.234 8.353h0ZM22.808 29.1c1.244-3.46 1.895-7.204 0-6.844-1.894.36-.529 3.808.888 6.124 1.416 2.317 4.107 4.912 5.253 3.404s-1.87-2.357-5.474-2.138c-3.605.218-6.168 2.56-4.99 3.442 1.177.881 3.08-.529 4.323-3.988Z", strokeLinecap: "square", stroke: "currentColor" })] }))] })));
};

exports.default = SvgFilePdf48;
